/**
 * Global "Show only Service Name" utilities.
 *
 * BillLineItem.service_description is stored as
 *     "Service Name (SVC_CODE) - Service Head Name (HEAD_CODE)"
 * (see HistoBillingTbl.js buildBillPayload). When the Custom Config flag
 * `show_only_service_name` is enabled, every renderer calls stripServiceHead()
 * to reduce that string to just:
 *     "Service Name"
 * The flag is cached client-side under key `show_only_service_name` (see
 * Signin.js on login) so we don't need to hit the API on every render.
 */
import { getCachevalue } from "./Services/CacheProviderService";

/** Read the flag from sessionStorage. */
export function isOnlyServiceName() {
  try {
    return getCachevalue("show_only_service_name") === "true";
  } catch {
    return false;
  }
}

const HEAD_TAIL_RE = /\s*\([^)]*\)\s*$/;

/**
 * Return just the service name portion of a service_description string.
 * If the flag is off, or the value is empty, returns the input unchanged.
 *
 * @param {string} desc         The stored service_description.
 * @param {boolean} [flag]      Override the config flag (default reads cache).
 */
export function stripServiceHead(desc, flag) {
  if (desc == null || desc === "") return "";
  const only = flag === undefined ? isOnlyServiceName() : !!flag;
  if (!only) return String(desc);
  const first = String(desc).split(" - ", 1)[0].trim();
  return first.replace(HEAD_TAIL_RE, "").trim();
}
